module.exports = __webpack_public_path__ + "static/media/drums.f00cd6a0.mp3";